<template>
  <span
    class="inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full select-none transition-all duration-200"
    :class="[colorClasses, clickable ? 'cursor-pointer' : '', strikethrough ? 'line-through' : '']"
    @click="$emit('click', $event)"
  >
    <slot name="prefix" />
    <span class="truncate">{{ label }}</span>
    <button
      v-if="removable"
      type="button"
      class="opacity-50 hover:opacity-100 focus:outline-none ml-0.5 leading-none transition-all duration-200"
      title="Remove"
      @click.stop="$emit('remove')"
    >
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </span>
</template>

<script>
export default {
  name: 'TagChip',
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'default',
      // Options: default, gray, emerald, indigo, purple, blue, amber, rose, red, secondary
    },
    removable: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    strikethrough: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove', 'click'],
  computed: {
    isInteractive() {
      return this.clickable || this.removable;
    },
    colorClasses() {
      const h = this.isInteractive;
      const map = {
        default: 'bg-white border border-gray-300 text-gray-700' + (h ? ' hover:border-gray-400' : ''),
        gray: 'bg-gray-100 border border-gray-300 text-gray-700' + (h ? ' hover:border-gray-400' : ''),
        primary: 'bg-primary-100 border border-primary-200 text-primary-900' + (h ? ' hover:border-primary-500' : ''),
        secondary: 'bg-secondary-100 border border-secondary-300 text-secondary-900' + (h ? ' hover:border-secondary-600' : ''),
        neutral: 'bg-neutral-100 border border-neutral-300 text-neutral-700' + (h ? ' hover:border-neutral-500' : ''),
        emerald: 'bg-emerald-100 border border-emerald-300 text-emerald-700' + (h ? ' hover:border-emerald-500' : ''),
        indigo: 'bg-indigo-100 border border-indigo-300 text-indigo-700' + (h ? ' hover:border-indigo-500' : ''),
        purple: 'bg-purple-100 border border-purple-300 text-purple-700' + (h ? ' hover:border-purple-500' : ''),
        blue: 'bg-blue-100 border border-blue-300 text-blue-700' + (h ? ' hover:border-blue-500' : ''),
        amber: 'bg-amber-100 border border-amber-300 text-amber-700' + (h ? ' hover:border-amber-500' : ''),
        rose: 'bg-rose-100 border border-rose-300 text-rose-700' + (h ? ' hover:border-rose-500' : ''),
        red: 'bg-red-100 border border-red-300 text-red-700' + (h ? ' hover:border-red-500' : ''),
      };
      return map[this.color] || map.gray;
    },
  },
};
</script>
